import { createElement, useMemo } from 'react';
import { scaleValueByResponse } from './ScaleConstants';
export function ScaleIcon({ highlighted, response, }) {
    return useMemo(() => {
        const scaleValue = scaleValueByResponse(response);
        const icon = highlighted ? scaleValue.hightlightIcon : scaleValue.icon;
        return createElement(icon);
    }, [highlighted, response]);
}
